
export function toPayload<T>(action: { payload: T }): T {
  return action.payload;
}
